export default __webpack_public_path__ + "static/media/uploadH1.f2ada447.png";